
export const FEATURES = {
    ERGONOMIC_JOB_ANALYSIS: 'Ergonomic_Job_Analysis',
    EJA_MACROS_DOWNLOAD: 'EJA_MACROS_DOWNLOAD',
    LB_HYBRID_SCHEME_DEFAULT: 'LB_HYBRID_SCHEME_DEFAULT',
    PMTS_MTM_BMW: 'PMTS_MTM_BMW',
    MERGE_EJA_RECORDS: 'MERGE_EJA_RECORDS',
    LB_SWCT_UTILIZATION: 'LB_SWCT_UTILIZATION',
    LB_EXCEL_IMPORT: 'LB_EXCEL_IMPORT',
    EJA_TIPS_DOCS: 'EJA_TIPS_DOCS',
    ASSEMBLY_AUTOMATION: 'ASSEMBLY_AUTOMATION',
    // Time Studies improvements phase (Outline, Improvements, Audit, Suggestions, Kaizen Notes).
    // When off, a study ends at the Time Study step.
    SD_IMPROVEMENTS: 'SD_IMPROVEMENTS',
}

export const featuresOrg = {
    [FEATURES.ERGONOMIC_JOB_ANALYSIS]: (organization) => organization.startsWith('3m') || organization.startsWith('retrocausal') || organization === 'occumedic',
    [FEATURES.EJA_MACROS_DOWNLOAD]: (organization) => organization.startsWith('3m') || organization.startsWith('retrocausal'),
    [FEATURES.LB_HYBRID_SCHEME_DEFAULT]: (organization) => organization.startsWith('3m'),
    [FEATURES.PMTS_MTM_BMW]: (organization) => organization.startsWith('bmw') || organization.startsWith('retrocausal','retro') && !['retrocausalhamzamiu4akf7spicncwzi'].includes(organization),
    [FEATURES.MERGE_EJA_RECORDS]: (organization) => organization.startsWith('3m') || organization.startsWith('retrocausal'),
    [FEATURES.LB_SWCT_UTILIZATION]: (organization) => organization.startsWith('bendix') || organization.startsWith('retrocausal'),
    [FEATURES.LB_EXCEL_IMPORT]: (organization) => organization.startsWith('boston') || organization.startsWith('retrocausal'),
    [FEATURES.EJA_TIPS_DOCS]: (organization) => organization.startsWith('3m') || organization.startsWith('retrocausal'),
    [FEATURES.ASSEMBLY_AUTOMATION]: (organization) => !organization.startsWith('safran'),
    // Enable for all orgs. To disable, e.g. (organization) => organization.startsWith('retrocausal')
    [FEATURES.SD_IMPROVEMENTS]: () => true,
}

// Synchronous check that doesn't depend on the orgFeatures store being populated (it is only
// filled once AppContent mounts), so it is safe in route guards and on a hard refresh.
export const isFeatureEnabledForOrg = (
    feature,
    organization = localStorage.getItem('organization')
) => Boolean(organization) && Boolean(featuresOrg[feature]?.(organization))
